oyc.Dropdown = {
  dependencies: ['FormCache'],
  selectors: {
    container: '.ui.dropdown',
    simple: '.ui.dropdown.is-simple',
    location: '.ui.dropdown.location-filter'
  },
  container: null,
  contentNavigation: null,
  init: function () {
    return new Promise((resolve, reject) => {
      this.container = $(this.selectors.container);

      if (0 < this.container.length) {
        this.contentNavigation = this.container.filter(this.selectors.simple);
        this.locationFilter = this.container.filter(this.selectors.location);
        if (this.locationFilter.length > 0) {
          this.container = this.container.not(this.selectors.location);
        }
        this.loadAsset().then(() => {
          this.initDropdowns();
          resolve();
        });
      } else {
        resolve();
      }
    })
  },

  loadAsset: function () {
    return Promise.all([
      oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/semantic-ui-transition.js'),
      oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/semantic-ui-api.js'),
      oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/semantic-ui-dropdown.js')
    ])
  },

  initDropdowns: function () {
    document.dispatchEvent(new CustomEvent('oyc:dropdown:initDropdowns'));
    if (this.container.closest(document).length === 0) {
      this.container.dropdown('destroy');
      $(this.selectors.container).dropdown('destroy');
      this.container = $(this.selectors.container);
    }
    this.container.dropdown('get placeholder text');
    this.container.dropdown('setting', {
      message: {
        count: '{count} ausgewählt',
        noResults: 'Keine Ergebnisse gefunden.'
      },
      selectOnKeydown: false
    });

    const scheduleFilter = this.container.filter('.schedule-filter');
    if (scheduleFilter.length) {
      scheduleFilter.dropdown('setting', {
        onChange: function (value) {
          if (value === '0') {
            $(this).dropdown('clear');
          }
        }
      })
    }
    // keep placeholder of jump navigation even after change
    if (this.contentNavigation.length) {
      this.contentNavigation.each(function () {
        const $dropdown = $(this);
        const placeholderText = $dropdown.dropdown('get placeholder text');
        $dropdown.dropdown({
          onChange: function () {
            $dropdown.dropdown('set text', placeholderText);
          }
        });
      });
    }
    if (this.locationFilter.length) {
      this.locationFilter.dropdown('setting', {
        showOnFocus: false,
        saveRemoteData: true,
        showNoResults: true,
        forceSelection: true,
        clearable: true,
        multiple: false,
        apiSettings: {
          url: oyc.static.Dropdown.locationSuggestUrl,
          method: 'POST',
          cache: false,
          beforeSend: function (settings) {
            let jEl = $(this);
            const value = jEl.find('.search').val().trim();
            if (value.match(/^\d{1,5}/)) {
              if (value.containsPostalCode()) {
                const sel = jEl.find('select');
                sel.html('<option value="' + value + '">' + value + '</option>')
                sel.val(value.returnPostalCode()).change();
                jEl.find('.text').text('');
              }
              return false;
            }
            // open console to inspect object
            settings.data.location = settings.urlData.query;
            return settings;
          },
        },
        minCharacters: 3
      }).on('click', this.clickLocation.bind(this))
        .on('keyup', '.search', this.changeLocationSearch.bind(this));
      this.locationFilter.parent().find('.icon').remove();
    }
  },
  close: function () {
    const openedDropdowns = this.container.find('.dropdown.is-opened');
    openedDropdowns.remove('is-opened');
  },
  clickLocation: function (ev) {
    const jEl = $(ev.currentTarget).closest('.ui.dropdown');
    const textContainer = jEl.find('.text');
    const search = jEl.find('.search');
    search.focus();
    const text = textContainer.text();
    if (0 < text.length && text.match(/PLZ/) === null) {
      search.val(this.replaceLocationAppendix(text));
      textContainer.text(text);
    }
    return false;
  },
  changeLocationSearch: function (ev) {
    if (ev.which > 36 && ev.which < 41) {
      return false;
    }
    let jEl = $(ev.currentTarget);
    let uiEl = jEl.parent();
    if (jEl.val().containsPostalCode()) {
      let val = jEl.val().returnPostalCode();
      jEl.val(val);
      uiEl.dropdown('set value', val);
      uiEl.dropdown('set text', val);
    } else if (0 === jEl.val().length) {
      uiEl.dropdown('restore default text');
      uiEl.find('.text').addClass('default');
      uiEl.dropdown('clear');
    }
  },
  replaceLocationAppendix(text) {
    if (typeof oyc.static.Dropdown.adjustedLocations !== 'undefined') {
      for (let key in oyc.static.Dropdown.adjustedLocations) {
        text = text.replace('' + oyc.static.Dropdown.adjustedLocations[key], key);
      }
    }
    text = text.replace(/\(.*/, '').trim();
    return text;
  },
  emptyList: function (dropdownEl) {
    dropdownEl.find('.menu').empty().append($('<div class="message">Keine Ergebnisse gefunden.</div>'));
    dropdownEl.dropdown('hide');
  },
}
